var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {}, [
    _c(
      "div",
      { staticClass: "d-flex gap-10" },
      [
        _c("download-selected-btn"),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "file-action-btn gap-10",
            class: {
              disabled:
                _vm.isNoneSelected === true ||
                _vm.complete !== true ||
                _vm.selectedOutputs.length !== 1 ||
                !_vm.canPreview(),
            },
            on: {
              click: function ($event) {
                return _vm.openPreview()
              },
            },
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "18",
                  height: "18",
                  viewBox: "0 0 24 24",
                },
              },
              [
                _c("path", {
                  attrs: {
                    fill: "currentColor",
                    d: "M12 6.5a9.77 9.77 0 0 1 8.82 5.5c-1.65 3.37-5.02 5.5-8.82 5.5S4.83 15.37 3.18 12A9.77 9.77 0 0 1 12 6.5m0-2C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5m0 5a2.5 2.5 0 0 1 0 5a2.5 2.5 0 0 1 0-5m0-2c-2.48 0-4.5 2.02-4.5 4.5s2.02 4.5 4.5 4.5s4.5-2.02 4.5-4.5s-2.02-4.5-4.5-4.5",
                  },
                }),
              ]
            ),
            _vm._v("\n      " + _vm._s(_vm._f("trans")("Preview"))),
          ]
        ),
        _vm._v(" "),
        true === false
          ? _c(
              "div",
              {
                staticClass: "file-action-btn gap-10",
                class: {
                  disabled:
                    _vm.isNoneSelected === true ||
                    _vm.complete !== true ||
                    _vm.selectedOutputs.length !== 1,
                },
              },
              [
                _c("i", { staticClass: "far fa-info-circle" }),
                _vm._v(" " + _vm._s(_vm._f("trans")("FileInfo"))),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }